/* eslint-disable max-statements */
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Divider } from 'primereact/divider';
import React, { useEffect, useState } from 'react';
import './Guidelines.scss';
import ConversationLogGuidelines from './ConversationLogGuidelines';
import NewConversationGuidelines from './NewConversationGuidelines';

interface guidelines {
    location: string;
    closeGuidelines: (message: boolean) => void;
}

const Guidelines = ({ location, closeGuidelines }: guidelines) => {
    const [visibleDiaglog, setVisibleDiaglog] = useState(true);
    const [label, setLabel] = useState('');

    useEffect(() => {
        if (location === 'ConversationLogs') {
            setLabel('Return to Discussion Logs');
        }
        if (location === 'NewConversationLog') {
            setLabel('Return to New Log');
        }
    }, [location]);
    const onHide = () => {
        setVisibleDiaglog(false);
        closeGuidelines(true);
    }
    const handlePrint = () => {
        const dialogContent = document.getElementById('guidelineHeader');
        if (dialogContent) {
            dialogContent.classList.add('print-mode');
            setTimeout(() => {
                window.print();
            }, 100);
        }
    }

    return (
        <Dialog
            header={
                <><div className="d-flex justify-content-between mb-2 " id='guidelineHeader'>
                    <h3>Discussion Log</h3>
                    <div>
                        <Button
                            data-testid='closeButton'
                            label={label}
                            className="btn-secondary me-2"
                            onClick={onHide} />
                        <Button
                            data-testid='printButton'
                            icon="pi pi-print"
                            className="btn-primary"
                            onClick={handlePrint}
                        />
                    </div>
                </div><Divider /></>}
            visible={visibleDiaglog}
            style={{
                width: location === 'NewConversationLog' ? '66vw' : '60vw',
                height: location === 'NewConversationLog' ? '90vh' : '40vh',
            }}
            position="center"
            onHide={onHide}
            closable={false}
            footer={location === 'NewConversationLog' && (
                <div id='guidelineFooter'><p className='guidelines' style={{ fontStyle: 'italic', marginBottom: '0px' }}>Ask yourself if what you’re <span>doing today</span> is getting you closer to where you want to <span>be tomorrow</span></p>
                    <p className='guidelines'>-Paulo Coelho</p></div>
            )}
        >
            <div className="row">
                {location === 'ConversationLogs' && (
                    <ConversationLogGuidelines />
                )}
                {location === 'NewConversationLog' && (
                    <NewConversationGuidelines />)}
            </div>
        </Dialog>
    );
};
export default Guidelines;
